









































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public data: any = [];
  public routeShow = false;
  public is996yinqing = false;
  public remark = "浙ICP备2022020573号"; // 996m2 :浙ICP备2022020573号 ; 996yinqing :浙ICP备19016587号
  public mounted() {
    const originUrl = location.host;
    if (originUrl.includes("996yinqing")) {
      this.remark = "浙ICP备19016587号";
      this.is996yinqing = true;
    }
  }
  public parentList(data) {
    this.data = data;
  }
  public toOpen(paths) {
    const routeUrl = this.$router.resolve({
      path: paths,
    });
    window.open(routeUrl.href, "_blank");
  }
}
